import { render } from "./Callback.vue?vue&type=template&id=7eda44e7&ts=true"
import script from "@/composables/pages/auth/callbackComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/pages/auth/callbackComposable.ts?vue&type=script&lang=ts"

import "./Callback.vue?vue&type=style&index=0&id=7eda44e7&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__